import api from 'shared/api'

const FETCH_REQUEST = 'memberDirectors/FETCH_REQUEST'
const FETCH_SUCCESS = 'memberDirectors/FETCH_SUCCESS'
const FETCH_FAILURE = 'memberDirectors/FETCH_FAILURE'
const UPDATE_REQUEST = 'memberDirectors/UPDATE_REQUEST'
const UPDATE_SUCCESS = 'memberDirectors/UPDATE_SUCCESS'
const UPDATE_FAILURE = 'memberDirectors/UPDATE_FAILURE'
const UPLOAD_REQUEST = 'memberDirectors/UPLOAD_REQUEST'
const UPLOAD_SUCCESS = 'memberDirectors/UPLOAD_SUCCESS'
const UPLOAD_FAILURE = 'memberDirectors/UPLOAD_FAILURE'

const UPLOAD_PROFILE_REQUEST = 'memberDirectors/UPLOAD_PROFILE_REQUEST'
const UPLOAD_PROFILE_SUCCESS = 'memberDirectors/UPLOAD_PROFILE_SUCCESS'
const UPLOAD_PROFILE_FAILURE = 'memberDirectors/UPLOAD_PROFILE_FAILURE'

const UPLOAD_SUPPORT_DOCS_REQUEST = 'memberDirectors/UPLOAD_SUPPORT_DOCS_REQUEST'
const UPLOAD_SUPPORT_DOCS_SUCCESS = 'memberDirectors/UPLOAD_SUPPORT_DOCS_SUCCESS'
const UPLOAD_SUPPORT_DOCS_FAILURE = 'memberDirectors/UPLOAD_SUPPORT_DOCS_FAILURE'

const initialState = {
  result: {
    member_director: {
      id: 0,
      first_name: "",
      last_name: "",
      title: "",
      gender: null,
      birth_date: null,
      main_interest: "directorship",
      email: "",
      mobile: "",
      area_code: "",
      director_id: null,
      location: {},
      sector: {},
      profile_setting: {},
      contact_setting: {},
      other_setting: {},
      cv_location: null,
      profile_image_location: null,
      profileCorrectionDataLocation: null,
      rating: "1",
      linked_in_url: "",
      comment: ""
    },
    search_companies: [],
  },
  loading: false,
  loaded: false,
  updating: false,
  updated: false,
  uploading: false,
  uploaded: false,
  uploadingProfile: false,
  uploadingSupportDocs: false,
  uploadedSupportDocs: false,
  uploadedProfile: false,
  correctionModalOpen: false,
  errors: {}
}

export function fetchRequest() {
  return {
    type: FETCH_REQUEST,
  }
}

export function fetchSuccess(payload) {
  return {
    type: FETCH_SUCCESS,
    payload,
  }
}

export function fetchFailure(errors) {
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

export function updateRequest() {
  return {
    type: UPDATE_REQUEST,
  }
}

export function updateSuccess(payload) {
  return {
    type: UPDATE_SUCCESS,
    payload,
  }
}

export function updateFailure(errors) {
  return {
    type: UPDATE_FAILURE,
    errors,
  }
}

export function uploadRequest() {
  return {
    type: UPLOAD_REQUEST,
  }
}

export function uploadSuccess(payload) {
  return {
    type: UPLOAD_SUCCESS,
    payload,
  }
}

export function uploadFailure(errors) {
  return {
    type: UPLOAD_FAILURE,
    errors,
  }
}

export function uploadProfileRequest() {
  return {
    type: UPLOAD_PROFILE_REQUEST,
  }
}

export function uploadProfileSuccess(payload) {
  return {
    type: UPLOAD_PROFILE_SUCCESS,
    payload,
  }
}

export function uploadProfileFailure(errors) {
  return {
    type: UPLOAD_PROFILE_FAILURE,
    errors,
  }
}

export function uploadProfileDocRequest() {
  return {
    type: UPLOAD_SUPPORT_DOCS_REQUEST,
  }
}

export function uploadProfileDocSuccess(payload) {
  return {
    type: UPLOAD_SUPPORT_DOCS_SUCCESS,
    payload,
  }
}

export function uploadProfileDocFailure(errors) {
  return {
    type: UPLOAD_SUPPORT_DOCS_FAILURE,
    errors,
  }
}

export function loadData(options = {}, cb) {
  return (dispatch) => {
    dispatch(fetchRequest())

    return api(`api/v1/member_directors`, options)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json)
        }

        dispatch(fetchSuccess(json))

        cb()
      })
      .catch((json) => {
        dispatch(fetchFailure(json.errors))
      })
  }
}

export function updateData(options = {}) {
  const config = {
    method: 'PATCH',
    body: JSON.stringify(options)
  }

  return (dispatch) => {
    dispatch(updateRequest())

    return api(`api/v1/member_directors/current`, {}, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json)
        }

        dispatch(updateSuccess(json))
      })
      .catch((json) => {
        dispatch(updateFailure(json.errors))
      })
  }
}

export function updateProfileData(options = {}) {
  const config = {
    method: 'PATCH',
    body: JSON.stringify(options)
  }

  return (dispatch) => {
    dispatch(updateRequest())

    return api(`api/v1/member_directors/update_profile_text`, {}, config)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json)
        }

        dispatch(updateSuccess(json))
      })
      .catch((json) => {
        dispatch(updateFailure(json.errors))
      })
  }
}

export function uploadCV(cvFile) {
  const form = new FormData()
  form.append("upload[cv]", cvFile)

  const config = {
    method: 'POST',
    body: form
  }

  return (dispatch, getState) => {
    const state = getState()
    dispatch(uploadRequest())

    return api(`api/v1/member_directors/upload`, {}, config, false, true)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json)
        }

        dispatch(uploadSuccess(json))
      })
      .catch((json) => {
        dispatch(uploadFailure(json.errors))
      })
  }
}

export function uploadSupportDocs(supportDocFile) {
  const form = new FormData()
  form.append("upload[support_docs]", supportDocFile)

  const config = {
    method: 'POST',
    body: form
  }

  return (dispatch, getState) => {
    const state = getState()
    dispatch(uploadProfileDocRequest())

    return api(`api/v1/member_directors/upload_correction_docs`, {}, config, false, true)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json)
        }
        dispatch(uploadProfileDocSuccess(json))
      })
      .catch((json) => {
        dispatch(uploadProfileDocFailure(json.errors))
      })
  }
}

export function uploadProfileImage(imageFile) {
  const form = new FormData()
  form.append("upload[profile]", imageFile)

  const config = {
    method: 'POST',
    body: form
  }

  return (dispatch, getState) => {
    const state = getState()
    dispatch(uploadProfileRequest())

    return api(`api/v1/member_directors/upload_profile`, {}, config, false, true)
      .then(response => response.json().then(json => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json)
        }

        dispatch(uploadProfileSuccess(json))
      })
      .catch((json) => {
        dispatch(uploadProfileFailure(json.errors))
      })
  }
}

// Reducer
export default function reducer(state = initialState, action = {}) {
  const { payload, type, errors } = action

  switch (type) {
    case FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true
      })
    case FETCH_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        loaded: true,
        errors: {},
        result: payload
      })
    case FETCH_FAILURE:
      return {
        ...state,
        loading: false,
        loaded: false,
        result: {
          ...state.result
        },
        errors: errors
      }
    case UPDATE_REQUEST:
      return Object.assign({}, state, {
        updating: true
      })
    case UPDATE_SUCCESS:
      return Object.assign({}, state, {
        updating: false,
        updated: true,
        errors: {},
        result: Object.assign({}, {...state.result, member_director: Object.assign({}, payload)})
      })
    case UPDATE_FAILURE:
      return {
        ...state,
        errors: errors,
        updating: false,
        updated: false,
        result: {
          ...state.result
        }
      }
    case UPLOAD_REQUEST:
      return Object.assign({}, state, {
        uploading: true
      })
    case UPLOAD_SUCCESS:
      return Object.assign({}, state, {
        uploading: false,
        uploaded: true,
        errors: {},
        result: Object.assign({}, {...state.result, member_director: Object.assign({}, payload)})
      })
    case UPLOAD_FAILURE:
      return {
        ...state,
        errors: errors,
        uploading: false,
        uploaded: false,
        result: {
          ...state.result
        }
      }
    case UPLOAD_PROFILE_REQUEST:
      return Object.assign({}, state, {
        uploadingProfile: true
      })
    case UPLOAD_PROFILE_SUCCESS:
      return Object.assign({}, state, {
        uploadingProfile: false,
        uploadedProfile: true,
        errors: {},
        result: Object.assign({}, {...state.result, member_director: Object.assign({}, payload)})
      })
    case UPLOAD_PROFILE_FAILURE:
      return {
        ...state,
        errors: errors,
        uploadingProfile: false,
        uploadedProfile: false,
        result: {
          ...state.result
        }
      }
      case UPLOAD_SUPPORT_DOCS_REQUEST:
        return Object.assign({}, state, {
          uploadingSupportDocs: true
        })
      case UPLOAD_SUPPORT_DOCS_SUCCESS:
        return Object.assign({}, state, {
          uploadingSupportDocs: false,
          uploadedSupportDocs: true,
          profileCorrectionDataLocation: Object.assign({}, payload.profile_correction_data_location),
          errors: {},
          result: Object.assign({}, {...state.result, member_director: Object.assign({}, payload)})
        })
      case UPLOAD_SUPPORT_DOCS_FAILURE:
        return {
          ...state,
          errors: errors,
          uploadingSupportDocs: false,
          uploadedSupportDocs: false,
          profileCorrectionDataLocation: null,
          result: {
            ...state.result
          }
        }
    default:
      return state
  }
}

